import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const TestimonialsSection = () => {
  const { isRTL } = useLanguage();

  const testimonials = [
    {
      name: "Ahmed Al-Rashid",
      nameAr: "أحمد الراشد",
      role: "Construction Director, Dubai",
      roleAr: "مدير البناء، دبي",
      text: "Jelani AI identified critical FIDIC compliance issues that could have cost us AED 2 million in disputes. The AI caught what our legal team missed - saved our entire project.",
      textAr: "حدد الجيلاني الذكي مشاكل امتثال FIDIC الحرجة التي كان من الممكن أن تكلفنا 2 مليون درهم في النزاعات. الذكاء الاصطناعي التقط ما فاته فريقنا القانوني - أنقذ مشروعنا بالكامل.",
      rating: 5
    },
    {
      name: "Sarah Johnson",
      nameAr: "سارة جونسون",
      role: "Legal Counsel, Engineering Firm",
      roleAr: "مستشار قانوني، شركة هندسية",
      text: "The 95% cost reduction is real. We review construction contracts in minutes instead of days. Jelani AI's FIDIC expertise is unmatched - it's like having a senior construction lawyer 24/7.",
      textAr: "انخفاض التكلفة بنسبة 95% حقيقي. نراجع عقود البناء في دقائق بدلاً من أيام. خبرة الجيلاني الذكي في FIDIC لا مثيل لها - إنه مثل وجود محامي بناء كبير على مدار الساعة.",
      rating: 5
    },
    {
      name: "Mohammed Hassan",
      nameAr: "محمد حسن",
      role: "Project Manager, Abu Dhabi",
      roleAr: "مدير المشروع، أبو ظبي",
      text: "Jelani AI prevents costly disputes before they happen. The Arabic contract support and GCC law compliance give us confidence in every project. Our legal costs dropped from AED 85,000 to AED 2,000 per month.",
      textAr: "جيلاني للذكاء الاصطناعي يمنع النزاعات المكلفة قبل وقوعها. دعم العقود باللغة العربية والامتثال لقوانين دول مجلس التعاون الخليجي يمنحنا الثقة في كل مشروع. انخفضت تكاليفنا القانونية من 85,000 درهم إماراتي إلى 2,000 درهم إماراتي شهريًا.",
      rating: 4.5
    }
  ];

  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;

    for (let i = 0; i < fullStars; i++) {
      stars.push(<i key={i} className="fas fa-star text-yellow-400"></i>);
    }
    
    if (hasHalfStar) {
      stars.push(<i key="half" className="fas fa-star-half-alt text-yellow-400"></i>);
    }

    return stars;
  };

  return (
    <section className={`py-20 bg-gradient-to-br from-blue-950 via-blue-800 to-blue-700 text-white ${isRTL ? 'rtl' : 'ltr'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold mb-4">
            {isRTL ? 'ماذا يقول أخصائيو البناء' : 'What Construction Professionals Say'}
          </h2>
          <p className="text-blue-200 max-w-3xl mx-auto">
            {isRTL ? 
              'شركات البناء والمحامون يثقون في الجيلاني الذكي لاحتياجات مراجعة العقود' : 
              'Construction firms and lawyers trust Jelani AI for their contract review needs'
            }
          </p>
          <div className="mt-6 bg-white/10 border border-white/15 rounded-lg p-4 max-w-2xl mx-auto">
            <p className="text-blue-100 font-medium">
              {isRTL ?
                'انضم إلى شركات البناء والمحامين الذين تحولوا بالفعل إلى الجيلاني الذكي' :
                'Join the construction firms and lawyers who have already switched to Jelani AI'
              }
            </p>
          </div>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <article
              key={index}
              aria-label={isRTL ? testimonial.nameAr : testimonial.name}
              dir={isRTL ? 'rtl' : 'ltr'}
              className={`bg-blue-700/85 border border-blue-300/20 shadow-xl p-8 rounded-xl staggered-animation ${isRTL ? 'text-right' : 'text-left'}`}
            >
              <div className="flex items-start gap-4 mb-4">
                <div
                  aria-hidden="true"
                  className="text-6xl leading-none text-white/35 font-serif shrink-0"
                >
                  “
                </div>
                <div>
                  <div className="font-semibold">
                    {isRTL ? testimonial.nameAr : testimonial.name}
                  </div>
                  <div className="text-blue-300 text-sm">
                    {isRTL ? testimonial.roleAr : testimonial.role}
                  </div>
                </div>
              </div>
              <p className={`italic mb-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                "{isRTL ? testimonial.textAr : testimonial.text}"
              </p>
              <div
                aria-label={`${testimonial.rating} star rating`}
                dir={isRTL ? 'rtl' : 'ltr'}
                className="flex justify-start"
              >
                {renderStars(testimonial.rating)}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
